import React from "react";
import ForgotPassword from "../../../Components/Auth/ForgotPassword";

const ForgotPasswordPage = () => <ForgotPassword />;

export default ForgotPasswordPage;
